import { AFSConfirmService, AFSModalComponent, AFSToastLoadingService } from '@afs-ng/overlays';
import { Component, input, InputSignal, OnInit, ViewChild } from '@angular/core';
import { AddressBase } from 'src/app/_interfaces/address';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { TicketBase } from 'src/app/_interfaces/ticket';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { SaveService } from 'src/app/_provider/save.service';
import { SupportEmployeeService } from 'src/app/_provider/support/support-employee.service';
import { TicketEmployee } from 'src/app/_provider/tickets/ticket.service';
import { TransferService } from 'src/app/_provider/transfer.service';
import { KundenPopoverPage } from 'src/app/_template/popover/kunden-popover/kunden-popover.page';

@Component({
    selector: 'support-assign-box',
    templateUrl: './support-assign-box.component.html',
    styleUrls: ['./support-assign-box.component.scss', '../assign.scss'],
    standalone: false
})
export class SupportAssignBoxComponent implements OnInit {

  public ticket: InputSignal<TicketBase> = input.required<TicketBase>()
  
  @ViewChild('ticketAssignModal') ticketAssignModal: AFSModalComponent

  public rejectMessage: string = ""

  constructor(
    private loadingSrv: AFSToastLoadingService,
    private supportEmployeeSrv: SupportEmployeeService,
    private confirmSrv: AFSConfirmService,
    private feedback: FeedbackService,
    public ticketSrv: TicketEmployee.TicketService,
    private transfer: TransferService,
    private saveSrv: SaveService.Ticket,
  ){}

  ngOnInit(): void {
    
  }

  public async openAssignModal(){
    if(!!this.ticket().addressSearchText) this.ticketAssignModal.show()
    else {

      const requestResult: boolean = await this.confirmSrv.confirm({
        title: "Adresse auswählen",
        message: "Bitte wählen Sie zuerst eine Adresse aus, bevor Sie das Ticket zuweisen.",
        acceptButton: {
          label: "Adresse auswählen",
        }
      })

      if(!requestResult) return
      

      //Erst Adresse auswählen wenn noch keine angeben wurde
      //note -> es ist so schlecht aber es wurde am anfang so gemacht und ich will es nicht ändern weil es sonst zu viel aufwand ist
      const result: HttpFunctionResult<AddressBase> = await this.feedback.showModal({
        component: KundenPopoverPage,
        componentProps: { type: "modal" }
      })

      if(!result.success) return

      this.ticketSrv.ticket.addressSearchText = result.data.description
      this.ticketSrv.ticket.address = result.data
      this.ticketSrv.contactPerson = null
      await this.saveSrv.saveAddress(result.data)
      this.transfer.setVALUE(null)
      this.ticketAssignModal.show()
    }
    
  }

  public async rejectRequest(){

    const rejectResponse: HttpFunctionResult<number> = await this.loadingSrv.showLoading({
      title: "Anfrage ablehnen",
      message: "Die Anfrage wird abgelehnt...",
      backdrop: true
    }, async () => await this.supportEmployeeSrv.rejectSupportTicketRequest(this.ticket().id, this.rejectMessage))

    if(!rejectResponse.success) return

    this.feedback.showInformationToast(`Die Anfrage "${this.ticket().description}" wurde erfolgreich abgelehnt.`, "Anfrage abgelehnt", 2000)
     
    this.ticketSrv.ticketDetailChanged({
      type: "SUPPORT_TICKET_ASSIGNED",
      data: null,
      ticketId: this.ticket().id
    })
    
  }

  public async assignTicketRequest(employeeIds: number[], ticketType: number){  

    const assignResponse: HttpFunctionResult<number> = await this.loadingSrv.showLoading({
      title: "Ticket wird zugewiesen...",
      message: "Bitte warten Sie, während das Ticket zugewiesen wird.",
      backdrop: true
    }, async () => await this.supportEmployeeSrv.acceptSupportTicketRequest(this.ticket().id, employeeIds, ticketType))

    if(!assignResponse.success) return


    this.ticketAssignModal.hide()
    this.feedback.showInformationToast(`Das Ticket "${this.ticket().description}" wurde erfolgreich zugewiesen.`, "Ticket zugewiesen", 2000)
 
    this.ticketSrv.ticketDetailChanged({
      type: "SUPPORT_TICKET_ASSIGNED",
      data: {...this.ticket(), lastUpdate: new Date(), art: ticketType},
      ticketId: this.ticket().id
    })

    this.ticketSrv.ticket.isCustomerRequest = false

    
  }
}
